import React from "react"
import BasicHero from "../../components/basic-hero"
import Calendly from "../../components/calendly/calendly"
import CTARow from "../../components/cta-row"
import { HandleImages } from "../../components/functions"
import Layout from "../../components/layout"
import Resource from "../../components/resource"
import ResourcesWrapper from "../../components/resources-wrapper"
import SEO from "../../components/seo"
import { seodata } from "../../components/seo-data"
import SimpleSlide from "../../components/simple-slide"
import SimpleSlider from "../../components/simple-slider"
import SocialSlider from "../../components/social-slider"
import logo from "../../images/involta-logo.svg"





var image;
var content = {
  hero: {
    title: (
      <span>
       Hands-On Cyber Training <br/> with Project Ares

      </span>
    ),
    text:
      <span>
      <p>  Build skills to better manage, monitor, and assess risk & vulnerabilities. In the wake of advancing technology, security professionals have to prioritize securing products and securing services. <strong>It puts a lot on their plate.</strong></p>
      <p>  Between log reviews, risk analysis, and continual monitoring, IT Technology professionals need training solutions to automate routine tasks while giving them the freedom to <strong>practice skills in ‘breakable environments’ </strong>to gracefully balance dual security responsibilities.</p>
      <p>Hands-on cyber training can alleviate concerns that come out of challenges with infrastructure security and product devops. <strong>Cyber training needs to be more than resumé building. </strong></p>
      </span>,
  },

  calendly: {
    text:  <span>We'd love to learn about your business or institution.<br/>  Schedule a consultation with us now.</span>,
  },


  cta1:{
    title:"Encourage progressive skill development of IT Technology professionals",
    text:"Upskill Cyber Teams with Artificial Intelligence and Gamified Learning.",
    url:"https://marketing.circadence.com/acton/media/36273/upskill-cyber-teams-with-artificial-intelligence-and-gamified-learning-whitepaper",
    cta:"Download"
  },
  cta2: {
    title: "Invest in your cyber security team!",
    text:
      "Learn more about Project Ares plans to keep professional's cyber skills sharp in your organization",
    url:
      "/project-ares",
    cta: "Learn More",
  },
  social:{
    social1:{
      image:"",
      title:"",
      text:<span>We look forward to implementing more time and training within the team utilizing Project Ares.<br/><span className="source">- Joshua Resch,<br/> SOC Manager at Involta</span><img className="testimony-logo" src={logo} alt="Involta Logo"/>
      </span>,
    
     
 
      url:"/learn/cyber-security-training-professionals"
    }
  },

  resources:{
    resource1:{
      
      title:<span>Gamification for Cyber Professional Development  <span>Info Sheet</span></span>,
      text:"Gamification for Cyber Professional Development Learn why gamified learning can support skills training and acquisition for today’s cyber security professionals.",
      url:"https://marketing.circadence.com/acton/attachment/36273/f-1ebf399b-baed-420b-a651-3156c6cf248c/1/-/-/-/-/Gamification%20Fact%20Sheet%20%28links%20to%20gamification%20blog%20post%29.pdf"
    },
    resource2:{
     
      title:<span>Cyber Ranges and How They Improve Security Training<span>Blog</span></span>,
      text:"Cyber Ranges and How They Improve Security Training Learn about the benefits of cyber range training environments and how they’ve evolved to optimize training for professionals.",
      url:"/blog/cyber-ranges-101-and-how-they-improve-security-training/"
    },
    resource3:{
      
      title:<span>How it's Built: Project Ares Missions <span>Webinar</span></span>,
      text:"How it’s Built: Project Ares Missions Hear from Project Ares mission designers who are real-life cyber operators themselves, on how they’ve built mission scenarios in the platform to help professionals built the best cyber skills possible.",
      url:"https://marketing.circadence.com/acton/media/36273/webinar-how-its-built-project-ares"
    }, 
  },
  simple:{
    simple1:{
      text:<span><strong>Build Your Resume:</strong> As you build your skills, align them to the NIST/NICE’s Work Role Framework.</span>,
    },
    simple2:{
      text:<span><strong>Rank Yourself:</strong> How will your scores and XP stack up to others? Friendly competition through gamified elements can motivate your training.</span>,
    },
    simple3:{
      text:<span><strong>Improve at Work:</strong> Train in realistic networks against real-world inspired threats to be better cyber defender for your organization.</span>,
    },
    simple4:{
      text:<span><strong>Cyber is Complex:</strong> Be prepared. Integrate skills and optimize strategic thinking abilities with multi-faceted cyber activities.</span>,
    },
    simple5:{
      text:<span><strong>Train on Your Own Schedule:</strong> with browser-based training available anytime, from any location.</span>,
    },
  }
}
 
 
class TechPage extends React.Component {
  render() {
    return (
      <Layout> <SEO title={seodata.tech.title} description={seodata.tech.description} keywords={seodata.tech.keywords} />
        <BasicHero 
        class="tech"
          title={content.hero.title}
          text={content.hero.text}
          image={<HandleImages name={'manWomanComputer'}/>}
        />
     
    
     <Calendly text={content.calendly.text} inv={true} bgColor={"bright-blue"} />
     
                
     <SocialSlider>
    <SimpleSlide   image={<HandleImages name={'manLaptop'}/>} text={content.social.social1.text} />
   
 

        </SocialSlider>


        <CTARow title={content.cta1.title} text={content.cta1.text} cta={content.cta1.cta} url={content.cta1.url} inv={false} bgColor={"deep-blue"} image={'document'}/>
        


        <h3>Additional Resources </h3>
        <ResourcesWrapper>
        <Resource  image={<HandleImages name={'gamification'}/>} title={content.resources.resource1.title} text={content.resources.resource1.text} url={content.resources.resource1.url}/>
        <Resource  image={<HandleImages name={'darkBG'}/>} title={content.resources.resource2.title} text={content.resources.resource2.text} url={content.resources.resource2.url}/>
        <Resource  image={<HandleImages name={'womanScreen'}/>} title={content.resources.resource3.title} text={content.resources.resource3.text} url={content.resources.resource3.url}/>
       
        </ResourcesWrapper>



        <SimpleSlider>
    <SimpleSlide   image={<HandleImages name={'pAScreen1'}/>} text={content.simple.simple1.text} />
    <SimpleSlide   image={<HandleImages name={'pAScreen2'}/>} text={content.simple.simple2.text} />
    <SimpleSlide   image={<HandleImages name={'pAScreen3'}/>} text={content.simple.simple3.text} />
    <SimpleSlide   image={<HandleImages name={'pAScreen4'}/>} text={content.simple.simple4.text} />
    <SimpleSlide   image={<HandleImages name={'pAScreen5'}/>} text={content.simple.simple5.text} />

        </SimpleSlider>
        <CTARow
          title={content.cta2.title}
          text={content.cta2.text}
          cta={content.cta2.cta}
          url={content.cta2.url}
          
          bgColor={"bright-blue"}
          image={"laptop"}
        />

      </Layout>
    )
  }
}

export default TechPage
